// Only for use in contextual color definitions
export const gray50 = '#f6f8fa';
export const gray80 = '#f0f4f6';
export const gray100 = '#e8ecf0';
export const gray150 = '#d4dae0';
export const gray200 = '#bdc5cf';
export const gray300 = '#98a1ae';
export const gray400 = '#747c8b';
export const gray500 = '#4d5768';
export const gray600 = '#373b4a';
export const gray700 = '#242733';
export const gray800 = '#141520';
export const gray900 = '#080811';
export const navy50 = '#f7fafc';
export const navy100 = '#e8ecf0';
export const navy150 = '#d9e2ec';
export const navy200 = '#bcccdc';
export const navy300 = '#9fb3c8';
export const navy400 = '#829ab1';
export const navy500 = '#627d98';
export const navy600 = '#486581';
export const navy700 = '#334e68';
export const navy800 = '#243b53';
export const navy900 = '#102a43';
export const blue50 = '#f5fcff';
export const blue100 = '#e3f0ff';
export const blue150 = '#b3d9ff';
export const blue200 = '#8bcafd';
export const blue300 = '#66b5fa';
export const blue400 = '#40a5f7';
export const blue500 = '#2b8fed';
export const blue600 = '#1980d4';
export const blue700 = '#1271bf';
export const blue800 = '#0b5fa3';
export const blue900 = '#034388';
export const green50 = '#fafffd';
export const green100 = '#effcf6';
export const green150 = '#c6f7e2';
export const green200 = '#8eedc7';
export const green300 = '#65d6ad';
export const green400 = '#3ebd93';
export const green500 = '#27ab83';
export const green600 = '#199473';
export const green700 = '#147d64';
export const green800 = '#0c6b58';
export const green900 = '#014d40';
export const orange50 = '#fffefa';
export const orange100 = '#fffbea';
export const orange150 = '#fff7c4';
export const orange200 = '#fcf088';
export const orange300 = '#f5e35d';
export const orange400 = '#f2d047';
export const orange500 = '#e6bb20';
export const orange600 = '#d4a31c';
export const orange700 = '#b88115';
export const orange800 = '#87540d';
export const orange900 = '#733309';
export const red50 = '#fff1f1';
export const red100 = '#ffe3e3';
export const red150 = '#ffbdbd';
export const red200 = '#ff9b9b';
export const red300 = '#f86a6a';
export const red400 = '#ef4e4e';
export const red500 = '#e12d39';
export const red600 = '#cf1124';
export const red700 = '#ab091e';
export const red800 = '#8a041a';
export const red900 = '#610316';
export const purple50 = '#f9f6fe';
export const purple100 = '#f2ebfe';
export const purple125 = '#e4d4ff';
export const purple150 = '#dac4ff';
export const purple200 = '#b990ff';
export const purple300 = '#a368fc';
export const purple400 = '#9446ed';
export const purple500 = '#8719e0';
export const purple600 = '#7a0ecc';
export const purple700 = '#690cb0';
export const purple800 = '#580a94';
export const purple900 = '#44056e';
export const white = '#ffffff';
export const black = '#000000';
export const hover = '#fafafa';
export const border = '#e8ecf0';
export const selected = '#b3d9ff';
